import { formatCurrency } from "../../utilities/general-utils";

const OpenBankingTransactions = ({
    transactions
}) => {
    return (
        <div>
            <table className="table-default">
                <thead>
                    <tr>
                        <th>TransactionID</th>
                        <th>AccountID</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Description</th>
                        <th>Memo</th>
                        <th>PostedDate</th>
                        <th>TransactionDate</th>
                        <th>CreatedDate</th>
                        <th>Categorization</th>
                    </tr>
                </thead>
                <tbody>
                    {transactions.map((transaction) => (
                        <tr key={`${transaction.id}-${transaction.createdDate}`}>
                            <td>{transaction.id}</td>
                            <td>{transaction.accountId}</td>
                            <td>{formatCurrency(transaction.amount)}</td>
                            <td>{transaction.status}</td>
                            <td>{transaction.description}</td>
                            <td>{transaction.memo}</td>
                            <td>{transaction.postedDate}</td>
                            <td>{transaction.transactionDate}</td>
                            <td>{transaction.createdDate}</td>
                            <td>
                                <div style={{
                                    maxHeight: '200px',
                                    overflow: 'auto',
                                }}>
                                    <pre>{JSON.stringify(transaction.categorization, null, 2)}</pre>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default OpenBankingTransactions;